<template>
  <div class="flex flex-col justify-between font-sans-serif">
    <div class="bg-background-academy text-center py-6 mb-4 text-white">
      <h1 class="w-full px-4
      font-bold tracking-widest uppercase text-md mb-2">
        {{ $t('cards.areYouSure') }}
      </h1>
      <h2>
        ({{ $t('cards.irreversible') }})
      </h2>
    </div>
    <div class="flex flex-row justify-between my-2 text-sm w-1/2 mx-auto mb-10">
        <button
          @click="$emit('close')"
          class="mx-2 py-3 rounded border hover:bg-background-academy
          border-background-academy w-1/2 hover:text-white
          text-background-academy font-bold
          cursor-pointer md:w-full">
            {{ $t('cards.cancel') }}
        </button>
        <button
          @click="deletePaymentMethod()" :class="isLoading ? 'loader' : ''"
          class="mx-2 py-3 rounded border w-1/2 hover:bg-background-academy
          border-background-academy hover:text-white
          text-background-academy font-bold
          cursor-pointer md:w-full">
            {{ $t('cards.delete') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['id'],

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      student: ['auth/student'],
    }),
  },

  methods: {
    deletePaymentMethod() {
      this.isLoading = true;
      axios.delete(`/api/students/${this.student.id}/payment-method?id=${this.id}`).then(() => {
        this.$store.dispatch('auth/deletedPaymentMethod');
        this.$emit('close');
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        this.$emit('close');
        this.console.log(error);
      });
    },
  },
};
</script>
